import { checkPermissions } from '@/utils/accesses'

function getSortKey(item) {
  if (item.displayIndex != null && item.displayIndex !== '') {
    return Number(item.displayIndex)
  }
  return item.order ?? 0
}

function sortByDisplayIndexOrOrder(items = []) {
  return [...items].sort((a, b) => getSortKey(a) - getSortKey(b))
}

export default {
  integrationsByCategory(state, getters, rootState) {
    const permissions = rootState.user?.userData?.permissions || []

    return [...state.categories]
      .sort((a, b) => getSortKey(a) - getSortKey(b))
      .map(category => ({
        ...category,
        integrations: sortByDisplayIndexOrOrder(
          (category.integrations || []).filter(item => {
            const required = item.permissions || []
            return !required.length || checkPermissions(permissions, required)
          }),
        ),
      }))
      .filter(section => section.integrations.length > 0)
  },
  getIntegrationById: (state, getters, rootState) => id => {
    const permissions = rootState.user?.userData?.permissions || []

    const fromDetail = state.integrationBySlug[id]
    if (fromDetail) {
      const required = fromDetail.permissions || []
      if (required.length && !checkPermissions(permissions, required)) return null
      return fromDetail
    }

    const fromCatalog = getters.integrationsByCategory
      .flatMap(section => section.integrations)
      .find(item => item.id === id)

    return fromCatalog || null
  },
}
